import 'primeicons/primeicons.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import "./platforms.css"
import React, { useState, useEffect } from 'react';
import { DataView } from 'primereact/dataview';
import { Button } from 'primereact/button';
import { NavLink } from 'react-router-dom';
import axiosWithAuth from '../../helpers/AxiosHelper';
import errorMessage, { describeError } from '../../helpers/errorMessage';
import { kebabCase } from 'lodash';
import { Dialog } from 'primereact/dialog';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { ToggleButton } from 'primereact/togglebutton';
import * as _ from 'lodash';
import PageHeader from '../common/PageHeader';
const emptyPlatform = {
    validate: false,
    spro_upload: false,
    map_data: false,
    data_types: [],
    platform_analytics: [],
    platform: '',
    _key: ''
}


export const Platforms = (props) => {
    const [platforms, setPlatforms] = useState(null);
    const [layout, setLayout] = useState('grid');
    const [newPlatformDialog, setNewPlatformDialog] = useState(false);
    const [newPlatform, setNewPlatform] = useState(emptyPlatform);
    const [submitted, setSubmitted] = useState(false);
    const [dialogError, setDialogError] = useState(null);
    // const [sortKey, setSortKey] = useState(null);
    // const [sortOrder, setSortOrder] = useState(null);
    // const [sortField, setSortField] = useState(null);
    // const sortOptions = [
    //     {label: 'Price High to Low', value: '!price'},
    //     {label: 'Price Low to High', value: 'price'},
    // ];

    useEffect(() => {
        props.setLoading(true);
        axiosWithAuth.get("/platforms")
            .then(data => {
                setPlatforms(data.data)
            }).catch(err => {
                alert(errorMessage(err));
            }).finally(()=>{
                props.setLoading(false);
            });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // const onSortChange = (event) => {
    //     const value = event.value;

    //     if (value.indexOf('!') === 0) {
    //         setSortOrder(-1);
    //         setSortField(value.substring(1, value.length));
    //         setSortKey(value);
    //     }
    //     else {
    //         setSortOrder(1);
    //         setSortField(value);
    //         setSortKey(value);
    //     }
    // }

    const renderListItem = (data) => {
        return (
            <div className="col-12">
                <div className="platform-list">
                    <NavLink className='platform-link' to={kebabCase(data.platform)}  >
                        <div className='platform-tile is-row'>
                            <span className='platform-tile-avatar' aria-hidden="true">{String(data.platform || '?').slice(0, 1).toUpperCase()}</span>
                            <span className='platform-tile-name'>{data.platform}</span>
                            <i className='pi pi-chevron-right platform-tile-chevron' aria-hidden="true" />
                        </div>
                    </NavLink>

                </div>
            </div>
        );
    }

    const renderGridItem = (data) => {
        return (
            <div className="col-12 md:col-6 xl:col-4">
                <div className='platform-grid'>
                    <NavLink className='platform-link' to={kebabCase(data.platform)}  >
                    {/* Tile card instead of a full primary button - a styled
                        div inside the link, so there's no <button> nested in
                        an <a>. */}
                    <div className='platform-tile'>
                        <span className='platform-tile-avatar' aria-hidden="true">{String(data.platform || '?').slice(0, 1).toUpperCase()}</span>
                        <span className='platform-tile-text'>
                            <span className='platform-tile-name'>{data.platform}</span>
                            <span className='platform-tile-hint'>Open configuration</span>
                        </span>
                        <i className='pi pi-chevron-right platform-tile-chevron' aria-hidden="true" />
                    </div>
                {/* <div className='platform-grid-button'>
                    
                       <span> {data.platform}</span>
                    
                    </div> */}
                    </NavLink>
                </div>
            </div>
        );
    }

    const itemTemplate = (product, layout) => {
        if (!product) {
            return;
        }

        if (layout === 'list')
            return renderListItem(product);
        else if (layout === 'grid')
            return renderGridItem(product);
    }
    const openNew = () => {
        // setNewPlatform(emptyPlatform);
        setSubmitted(false);
        setNewPlatformDialog(true);
    }
    // "Add New Platform" now lives in the PageHeader's actions (same
    // onClick) instead of the DataView's own header row.
    const renderHeader = () => {
        return (
            <PageHeader
                title="Originators"
                subtitle="Configure how each Originator's files are validated, mapped and uploaded."
                icon="pi-building"
                actions={<Button label="Add New Originator" icon="pi pi-plus" onClick={openNew} />}
            />
        );
    }


    const header = renderHeader();

    // New Platform Dialog stuff

    // Same rule as the backend: names differing only in case, spaces, hyphens
    // or underscores are the same Originator. Returns the clashing name, if any.
    const normalizeName = (name) => String(name || '').toLowerCase().replace(/[\s_-]/g, '');
    const findExistingPlatform = (name) =>
        (platforms || []).find((item) => normalizeName(item.platform) === normalizeName(name))?.platform;

    const onAddNewPlatform = () => {
        setSubmitted(true);
        setDialogError(null);
        if (_.isNil(newPlatform.platform) || _.isEmpty(newPlatform.platform)) return;
        const existing = findExistingPlatform(newPlatform.platform);
        if (existing) {
            setDialogError(`An Originator with this name already exists (${existing}).`);
            return;
        }
        props.setLoading(true);
        newPlatform['_key'] = generate_key(newPlatform.platform)
        axiosWithAuth.post("/platforms",newPlatform).then(() => {
            return axiosWithAuth.get("/platforms");
        }).then(data => {
            setPlatforms(data.data)
            setNewPlatform(emptyPlatform);
            hideDialog();
        }).catch(async err => {
            setDialogError(await describeError(err, 'Originators: add new Originator'));
        }).finally(()=>{
            props.setLoading(false);
        });
    }

    const generate_key = (platformName) => {
        return kebabCase(platformName)
        // return String(platformName).replace("")
    }

    const hideDialog = () => {
        // setNewPlatform(emptyPlatform);
        setSubmitted(false);
        setDialogError(null);
        setNewPlatformDialog(false);
    }
    const newPlatformDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={onAddNewPlatform} />
        </React.Fragment>
    );



    const MyToggleButton = ({
        label,
        name,
        value,
        handleChange,
        ...props
    }) => (<div className="field platform-toggle-row">
        {/* <InputText id="name" name="name" value{formik.values.name} onChange={formik.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid('name') })} /> */}
        <label  htmlFor={name}>{label}</label >
        <ToggleButton id={name} name={name} checked={value} onIcon="pi pi-check" offIcon="pi pi-times" onChange={handleChange} className="platform-toggle" {...props} />

    </div>);

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _newPlatform = { ...newPlatform };
        _newPlatform[`${name}`] = val;
        setNewPlatform(_newPlatform);
    }


    return (
        <div className="content-container">
            {header}
            <div className="platforms-dataview" style={{ maxWidth: "100%" }}>
                <DataView value={platforms} layout={layout} sortField="platform" sortOrder={1}
                    itemTemplate={itemTemplate} paginator rows={27} />
            </div>
            <Dialog visible={newPlatformDialog} style={{ width: '450px' }} header="Add a new Originator to Exaport" modal className="p-fluid platform-dialog" footer={newPlatformDialogFooter} onHide={hideDialog}>
                <div className="field platform-dialog-name">
                    <span className="p-float-label">
                        <InputText required name='platform_name' value={newPlatform.platform} onChange={(e) => onInputChange(e, 'platform')}  className={classNames({ 'p-invalid block': submitted && !newPlatform.platform })} />
                        <label  htmlFor='platform_name'>Name of Originator</label>
                    </span>
                    {submitted && !newPlatform.platform && <small className="p-error">Originator Name is required.</small>}
                    {dialogError && <small className="p-error block mt-2">{dialogError}</small>}
                </div>
                <div className="platform-dialog-section-label">Processing</div>
                <MyToggleButton label='Basic Validation' name="validate" value={newPlatform.validate} handleChange={(e) => onInputChange(e, 'validate')} />
                <MyToggleButton label='Upload to S-Pro' name="spro_upload" value={newPlatform.spro_upload} handleChange={(e) => onInputChange(e, 'spro_upload')}/>
                <MyToggleButton label='Map Data' name="map_data" value={newPlatform.map_data} handleChange={(e) => onInputChange(e, 'map_data')}/>
            </Dialog>
        </div>
    );
}
